<template>
    <div v-if="timer">
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-alert outlined class="my-0" :color="timer.noExiste? 'red' : 'primary'" dense :style="estiloTimerActivo()">
                        <v-row dense>
                            <v-col>
                                <div class="d-flex flex-no-wrap justify-space-between">
                                    <v-card-title class="headline vcard_timer" style="bold" :disabled="timer.noExiste">
                                        <span v-if="timer.noExiste">{{timer.idCliente}} - {{timer.cliente}}</span> 
                                        <span v-else>{{timer.cliente}}</span> 
                                    </v-card-title>
                                    <v-card-title class="headline vcard_timer">
                                        <ArdiContextMenu :contextMenu="contextMenu" />
                                    </v-card-title>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row v-if="timer.observaciones.length > 0">
                            <v-col cols="12" class="pt-0">
                                <v-alert dense outlined text class="mx-4 my-0" color="info">
                                    <p class="body-2 mb-0"><v-icon color="info" class="mr-2">mdi-information-outline</v-icon>
                                        {{ timer.observaciones }}
                                    </p>
                                </v-alert>
                            </v-col>
                        </v-row>
                        <v-row v-if="timer.contratos.length === timerContratosBolsa.length">
                            <v-col cols="12" class="pt-0">
                                <v-alert dense outlined text class="mx-4 text-center my-0" color="warning">
                                    <p class="body-2 mb-0"><v-icon color="warning" class="mr-2">mdi-alert-outline</v-icon>
                                    <strong>Cliente sin contratos.</strong> Antes de realizar la intervención hay que avisar al cliente de que la acción se facturará.</p>
                                </v-alert>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="text-center" cols="12" md="3">
                                <v-card-subtitle class="text-h5 vcard_timer">
                                    {{ (10 > timer.hora) ? '0' + timer.hora : timer.hora }} : 
                                    {{ (10 > timer.minuto) ?  '0' + timer.minuto : timer.minuto }} : 
                                    {{ (10 > Math.trunc(timer.segundo)) ? '0' + Math.trunc(timer.segundo) : Math.trunc(timer.segundo) }}
                                </v-card-subtitle>
                                <v-list-item-icon class="mx-3">
                                    <v-btn icon :disabled="timer.noExiste">
                                        <v-icon @click="dialogReiniciar = true">mdi-reload</v-icon>
                                    </v-btn>
                                </v-list-item-icon>
                                <v-list-item-icon class="mx-3">
                                    <v-btn icon :disabled="timer.noExiste">
                                        <v-icon v-if="!running" @click="iniciarTimer">mdi-play</v-icon>
                                        <v-icon v-else @click="pausarTimer(), setTabConTimerActivo('parado')">mdi-pause</v-icon>
                                    </v-btn>
                                </v-list-item-icon>
                                <v-list-item-icon class="mx-3">
                                    <v-btn icon :disabled="timer.noExiste">
                                        <v-icon @click="mostrarDialog(), setTabConTimerActivo('parado')">mdi-calendar-check</v-icon>
                                    </v-btn>
                                </v-list-item-icon>
                            </v-col>
                            <v-col cols="12" md="1">  
                                <v-text-field v-model="timer.contacto" class="mr-2" label="Contacto" :value="timer.contacto" :disabled="timer.noExiste"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="8">
                                <v-textarea 
                                    v-model="timer.comentarios" 
                                    class="mx-2" 
                                    label="Comentarios" 
                                    rows="3" 
                                    :value="timer.comentarios" 
                                    hide-details  
                                    :disabled="timer.noExiste"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-alert > 
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-dialog v-model="dialogEliminar" persistent max-width="380">
                <v-card>
                    <v-card-title class="headline">¡Atención!</v-card-title>
                    <v-card-text>¿Estás seguro de que quieres eliminar el timer?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogEliminar = false">Cancelar</v-btn>
                        <v-btn color="error" text @click="eliminarTimer()">Eliminar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row justify="center">
            <ComentariosGuardados 
                :dialogComentariosGuardados="dialogComentariosGuardados" 
                @close="dialogComentariosGuardados = false"
                @aceptar="insertarComentario"
            />
            <v-dialog v-model="dialogReiniciar" persistent max-width="380">
                <v-card>
                    <v-card-title class="headline">¡Atención!</v-card-title>
                    <v-card-text>¿Estás seguro de que quieres reiniciar el timer?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogReiniciar = false">Cancelar</v-btn>
                        <v-btn color="error" text @click="reiniciarTimer">Reiniciar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row justify="center">
            <ArdiImproveWriting v-if="dialogImproveWriting" :showDialog.sync="dialogImproveWriting" :textToImprove.sync="timer.comentarios" @accept="updateComment" />
        </v-row>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import ComentariosGuardados from '../comentariosGuardados/ComentariosGuardados.vue'
import ArdiContextMenu from '@/components/ArdiContextMenu'
import ArdiImproveWriting from '@/components/ArdiImproveWriting'
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

export default {
    name: 'Timer',
    data() {
        return {
            interval: null,
            running: false,
            timer: {},
            dialogEliminar: false,
            dialogReiniciar: false,
            dialogImproveWriting: false,
            headersEditar: [
                {
                    text: '',
                    filterable: false,
                    sortable: false,
                    value: 'seleccion'
                },
                {
                    text: 'Cliente',
                    filterable: true,
                    value: 'nombre',
                },
                {
                    text: 'Tiempo',
                    filterable: true,
                    value: 'tiempo',
                },
            ],
            timerEliminado: false,
            desmontandoComponente: false,
            dialogComentariosGuardados: false
        }
    },
    components: {
      ComentariosGuardados,
      ArdiContextMenu,
      ArdiImproveWriting
    },
    created() {
        this.timer = this.timers.find(timer => {
            return timer.id === this.$vnode.key            
        });
        if (this.idTimerActivo === this.timer.idCliente){
            this.iniciarTimer();
        }  
        
        this.setSumarCantidadTimersTotal();
    },
    methods: {
        ...mapActions(['setSnackbar', 'setLoading']),
        ...mapActions('arditimer', ['setDialog', 'setIdTimerActivo', 'setEliminarTimer', 'setTimers', 'setTimersGrupo','setAutoGuardado', 'setTabConTimerActivo', 'setCargarDatosDialog', 'setSumarCantidadTimersTotal', 'setRestarCantidadTimersTotal', 'setErrorGuardado', 'setCantidadTimersTotal', 'setCopiaCantidadTimersTotal', 'setCerrarSesion', 'setGuardando']),
        ...mapActions('login', ['setForzadoCerrarSesion']),    
        async iniciarTimer(){      
            this.setTabConTimerActivo('')
            this.setIdTimerActivo(this.$vnode.key);
            this.running = true;
            // Obtengo el tiempo al iniciar el timer
            let tiempoInicio = Date.now();
            this.interval = setInterval(() => {
                // Obtengo el tiempo actual
                let tiempoActual = Date.now();
                // Comparando el tiempo actual con el tiempo del inicio, podemos saber cuantos segundos han pasado
                let tiempoTranscurrido = ((tiempoActual-tiempoInicio)/1000);
                this.timer.segundo = this.timer.segundo + tiempoTranscurrido;

                if (this.timer.segundo == 60){
                    this.timer.minuto++;
                    this.timer.segundo = this.timer.segundo - 60;
                }else if(this.timer.segundo > 60){
                    let calculoTiempo = (this.timer.segundo/60).toString(); //convertimos los segundos en minutos
                    calculoTiempo = calculoTiempo.split(".");
                    this.timer.segundo = parseInt((this.timer.segundo % 60).toString().substr(0,2));//calculo de los segundos
                    this.timer.minuto = this.timer.minuto + parseInt(calculoTiempo[0]); //sumo los minutos que ya había con los nuevos
                }

                if (this.timer.minuto == 60){
                    this.timer.hora++;
                    this.timer.minuto = this.timer.minuto - 60;
                }else if(this.timer.minuto > 60){
                    let calculoTiempo = (this.timer.minuto/60).toString(); //convertimos los minutos en horas
                    calculoTiempo = calculoTiempo.split(".");
                    this.timer.minuto = parseInt((this.timer.minuto % 60).toString().substr(0,2));//calculo de los minutos
                    this.timer.hora = this.timer.hora + parseInt(calculoTiempo[0]); //sumo las horas que ya había con las nuevas
                }

                // Igualo el tiempo actual al inicial para que la próxima iteración cuente los segundos que han pasado desde la última iteración
                tiempoInicio = tiempoActual;
            },100);
        },
        reiniciarTimer(){
            if(this.idTimerActivo == this.$vnode.key){
                this.setTabConTimerActivo('parado');
            }
            this.dialogReiniciar = false;
            this.pausarTimer();
            this.timer.hora = 0;
            this.timer.segundo = 0;
            this.timer.minuto = 0;
            let date = new Date;
            this.timer.horaInicio = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()); //restablecemos hora inicio a la actual
        },
        pausarTimer(){
            this.running = false;
            clearInterval(this.interval);
            this.interval = null;
        },
        async eliminarTimer(){
            this.setLoading(true);
            try{
                await axios.delete('/api/arditimers/'+ this.timer.id);
                this.setEliminarTimer(this.timer);
                this.interval = null;
                this.timerEliminado = true;
                this.setRestarCantidadTimersTotal();
                this.setLoading(false);
            } catch (error) {
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se ha podido eliminar el timer'
                });
            }
        },
        async mostrarDialog(){
            // this.setCopiaCantidadTimersTotal(this.cantidadTimersTotal);
            this.pausarTimer();
            this.setIdTimerActivo(this.$vnode.key);
            this.setCargarDatosDialog(true);
        },
        async autoGuardadoBDD(){
             try{
                await axios.patch('/api/arditimers', this.timer);
            } catch (error) {
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido autoguardar los timers'
                });
            }
            // if(this.desmontandoComponente == false){
            //     this.setLoading(true);
            // }

            // try{
            //     await axios.patch('/api/arditimers', this.timer);
            // } catch (error) {
            //     this.setErrorGuardado(true);
            // }
            
            // if(this.cerrarSesion === false){
            //     this.setCopiaCantidadTimersTotal(this.cantidadTimersTotalCopia - 1);
            //         console.log(this.cantidadTimersTotalCopia);
            //     if(this.cantidadTimersTotalCopia == 0  || this.cantidadTimersTotalCopia == 1){
            //         // if(this.desmontandoComponente == true || (this.cantidadTimersTotalCopia == 0 && this.desmontandoComponente == false)){
            //             this.avisoGuardado();
            //             if(this.desmontandoComponente == false){
            //                 this.setLoading(false);
            //             }else{
            //                 this.setRestarCantidadTimersTotal();

            //             }
            //             if(this.errorGuardado == false){
            //                 this.setAutoGuardado(this.autoGuardado);   
            //             }
            //         // }
            //     }
            // }
            
            if(this.cerrarSesion === true){
                // console.log(this.cantidadTimersTotal);
                this.setRestarCantidadTimersTotal();
                if(this.cantidadTimersTotal <= 1){
                    this.setCerrarSesion(null);
                    this.setSnackbar({
                        tipo: 'green',
                        mensaje: 'Los timers se han guardados correctamente.'
                    });
                    this.setForzadoCerrarSesion(true);
                }
            }
        },
        // avisoGuardado(){
            // if(this.errorGuardado == false){
                // this.setSnackbar({
                //     tipo: 'green',
                //     mensaje: 'Los timers se han guardados correctamente.'
                // });
            // }else{
                // this.setErrorGuardado(false);
                // this.setSnackbar({
                //     tipo: 'error',
                //     mensaje: 'Error. No se han podido guardar los timers.'
                // });
            // }
            // this.setGuardando(false);
        // },
        avisoTimerPausado(){
            this.pausarTimer();
            this.setSnackbar({
                tipo: 'info',
                mensaje: 'El timer de ' + this.timer.cliente + ' estaba activo y ha sido pausado!'
            });
        },
        estiloTimerActivo(){
            if(this.idTimerActivo == this.timer.id && this.contieneTimerActivo != 'parado'){
                if(this.$vuetify.theme.dark){
                    return 'border: 2px solid !important; background-color: #2a3540 !important;'
                }
                return 'border: 2px solid !important; background-color: #eaf0ff !important;'
            }
        },
        abrirDialogComentariosGuardados(){
            this.dialogComentariosGuardados = true
        },
        abrirDialogMejorarEscritura(){
            this.dialogImproveWriting = true
        },
        abrirDialogEliminar(){
            this.dialogEliminar=true
            this.pausarTimer()
            this.setTabConTimerActivo('parado')
        },
        insertarComentario(comentarios){
            console.log(this.timer)
            if(this.timer.comentarios === null) this.timer.comentarios = ''
            if(this.timer.comentarios.length > 0) this.timer.comentarios += '\n'
            comentarios.forEach((comentario, index, comentarios) => {
                this.timer.comentarios += comentario.texto
                if(index < comentarios.length-1){
                    this.timer.comentarios += '\n'
                }
            });
            this.dialogComentariosGuardados = false
        },
        updateComment(improvedComment){
            this.timer.comentarios = improvedComment
        }
    },
    computed: {
        ...mapState('arditimer', ['idTimerActivo', 'timers', 'timersGrupos', 'autoGuardado', 'dialog', 'contieneTimerActivo', 'cantidadTimersTotal', 'cantidadTimersTotalCopia', 'cerrarSesion', 'errorGuardado', 'ultimoTimer']),
        ...mapState('login', ['forzadoCerrarSesion']),
        timerContratosBolsa() {
            return this.timer.contratos.filter(c => c.bolsa == 0).length;
        },
        contextMenu() {
            return [
                {
                    title: 'Eliminar',
                    icon: 'mdi-delete',
                    color: 'error',
                    event: this.abrirDialogEliminar
                },
                {
                    title: 'Comentarios guardados',
                    icon: 'mdi-playlist-star',
                    color: 'default',
                    event: this.abrirDialogComentariosGuardados
                },
                {
                    title: 'Mejorar escritura',
                    icon: 'mdi-text',
                    color: 'default',
                    showIaLabel: true,
                    disabled: !this.timer.comentarios?.trim(),
                    event: this.abrirDialogMejorarEscritura
                }
            ]
        }
    },
    watch: {
        idTimerActivo(){
            // Cuando el id del timer activo cambia (se ha iniciado otro timer, se está imputando otro timer) detiene todos los timers que no tienen ese id (no es el timer activo)
            if(this.idTimerActivo !== this.$vnode.key && this.interval !== null){
                this.avisoTimerPausado();
            }
        },
        autoGuardado(){
            this.autoGuardadoBDD();
        }
    },
    beforeDestroy(){
        // this.desmontandoComponente = true;
        if(this.timerEliminado){
            this.timerEliminado = false;
        }else if(this.cerrarSesion === false){
            this.autoGuardadoBDD();
            this.setRestarCantidadTimersTotal();
        }
        
        if(this.interval !== null){
            this.avisoTimerPausado();
        }
        
        this.setIdTimerActivo('');
    }
}
</script>

<style>
    .vcard_timer{
        word-break: break-word !important;
        padding: 0px 14px !important;
    }
</style>